<script setup>
import { ref } from 'vue';

const props = defineProps({
  id: {
    required: true,
    type: String,
  },
  classPrefix: {
    type: String,
    required: false,
  },
});

const listboxRef = ref(null);

defineExpose({ listboxRef });
</script>

<template>
  <ul
    :id="props.id"
    class="c-base-listbox"
    :class="`${classPrefix}listbox`"
    role="listbox"
    ref="listboxRef"
  >
    <slot />
  </ul>
</template>

